import api from './api';

// Completed visits with no signed note (documentation/revenue leak)
export function getUndocumentedVisits(params) {
  return api.get('/clinical/undocumented-visits', { params });
}

// SOAP Notes
export function getSoapNotes(params) {
  return api.get('/clinical/soap-notes', { params });
}

export function getSoapNote(id) {
  return api.get(`/clinical/soap-notes/${id}`);
}

export function createSoapNote(data) {
  return api.post('/clinical/soap-notes', data);
}

export function updateSoapNote(id, data) {
  return api.put(`/clinical/soap-notes/${id}`, data);
}

export function signSoapNote(id, body = {}) {
  return api.post(`/clinical/soap-notes/${id}/sign`, body);
}

export function batchSignSoapNotes({ noteIds, auditProvenanceById = {}, expectedUpdatedAtById }) {
  return api.post('/clinical/soap-notes/batch-sign', {
    note_ids: noteIds,
    expected_updated_at_by_id: expectedUpdatedAtById,
    audit_provenance_by_id: auditProvenanceById,
  });
}

// Co-sign workflow — one DC drafts, another reviews + signs.
export function submitSoapForReview(id, payload) {
  return api.post(`/clinical/soap-notes/${id}/submit-for-review`, payload);
}

export function returnSoapToDrafter(id, payload) {
  return api.post(`/clinical/soap-notes/${id}/return-to-drafter`, payload);
}

export function getCosignInbox() {
  return api.get('/clinical/soap-notes/cosign-inbox').then((r) => r.data);
}

export function getCosignSuggestedReviewer(patientId) {
  return api.get('/clinical/cosign-suggested-reviewer', {
    params: patientId ? { patient_id: patientId } : undefined,
  }).then((r) => r.data);
}

export function deleteSoapNote(id) {
  return api.delete(`/clinical/soap-notes/${id}`);
}

// ChiroFusion clinical snapshot for a migrated patient's first note.
export function getCfPrefill(patientId) {
  return api.get(`/clinical/cf-prefill/${patientId}`).then((r) => r.data);
}

// Owner-only — voids a signed note (preserves the row + audit trail,
// flags status='voided', voids attached claims).
export function voidSoapNote(id, voidReason) {
  return api.post(`/clinical/soap-notes/${id}/void`, { void_reason: voidReason });
}

export function amendSoapNote(id, data) {
  return api.post(`/clinical/soap-notes/${id}/amend`, data);
}

export function getAmendments(id) {
  return api.get(`/clinical/soap-notes/${id}/amendments`);
}

export function getFromPrevious(patientId) {
  return api.post(`/clinical/soap-notes/from-previous/${patientId}`);
}

export function generateNarrative(noteData, patientId) {
  return api.post('/clinical/soap-notes/generate-narrative', { note_data: noteData, patient_id: patientId });
}

// Templates
export function getTemplates(category) {
  return api.get('/clinical/templates', { params: { category: category || undefined } });
}

export function createTemplate(data) {
  return api.post('/clinical/templates', data);
}

export function updateTemplate(id, data) {
  return api.put(`/clinical/templates/${id}`, data);
}

export function deleteTemplate(id) {
  return api.delete(`/clinical/templates/${id}`);
}

// Care Plans
export function getCarePlans(params) {
  return api.get('/clinical/care-plans', { params });
}

export function createCarePlan(data) {
  return api.post('/clinical/care-plans', data);
}

export function updateCarePlan(id, data) {
  return api.put(`/clinical/care-plans/${id}`, data);
}

export function updateCarePlanStatus(id, status) {
  return api.patch(`/clinical/care-plans/${id}/status`, { status });
}

export function previewVoidSoapNote(id) { return api.get(`/clinical/soap-notes/${id}/void-preview`); }
